import jalaliMoment from "jalali-moment";

export function gregorianDate(timestamp, format = 'jYYYY/jMM/jDD') {
  const date = new Date(timestamp);
  const jalaliDate = jalaliMoment(date);
  return jalaliDate.format(format)
}